class BlockSav{

	constructor() {

		this.blocks = document.querySelectorAll('.block-sav');

		this.blocks.forEach( (block) =>  {

			let lines = block.querySelectorAll(".sav-line");

			gsap.to(lines[0], {
				x : - (lines[0].offsetWidth - window.innerWidth),
				scrollTrigger: {
					trigger: block,
					start : "top bottom",
					end : "bottom top",
					scrub: 1
				}
			});

			gsap.to(lines[1], {
				x : 0,
				scrollTrigger: {
					trigger: block,
					start : "top bottom",
					end : "bottom top",
					scrub: 1
				}
			});

		});

	}

}